
const queueTypes = ['quorum', 'classic'];

const exchangeTypes = ['headers', 'direct', 'fanout'];

export const isQueueType = (type: string): boolean => {
  return queueTypes.includes(type);
}

export const isExchangeType = (type: string): boolean => {
  return exchangeTypes.includes(type);
}

export const bindingArgumentsComparison = (obj: any, other: any): boolean => {
  const a = obj || {};
  const b = other || {};
  const hasMatchingKeys = (left: any, right: any): boolean =>
    (Object.keys(left) as (keyof typeof left)[]).every((key) => {
      if (key === 'x-match-all' || key === 'x-match-any') {
        return true;
      }
      return Object.prototype.hasOwnProperty.call(right, key) && left[key] === right[key];
    });

  return hasMatchingKeys(a, b) && hasMatchingKeys(b, a);
};